module.exports = __webpack_public_path__ + "img/youtube.41894df5.svg";